import { Chip } from 'macaron-frontend-ui'
import ReadMoreAccordion from '~/components/ReadMoreAccordion'
import { type FragmentType, getFragmentData, graphql } from '~/lib/graphql'
import { spotListLink } from '~/lib/spot/link'
import { useIsPC } from '~/lib/ua'
import { hstack } from '~/styled-system/patterns'
import { GuideSection } from './GuideSection'

const RestaurantNearbySpots = graphql(/* GraphQL */ `
  fragment RestaurantNearbySpots on Restaurant {
    nearbySpots {
      spotId
      name
      type
      minimumArea {
        code
        parent {
          code
          parent {
            key
          }
        }
      }
    }
  }
`)

type Props = {
  restaurant: FragmentType<typeof RestaurantNearbySpots>
}

export function NearbySpots({ restaurant }: Props) {
  const isPc = useIsPC()
  const { nearbySpots } = getFragmentData(RestaurantNearbySpots, restaurant)

  if (nearbySpots.length == 0) {
    return null
  }

  const links = nearbySpots.map(spotListLink).map((link, i) => {
    // 静的なリストなので要素のインデックスをkeyにする
    return (
      <li key={i}>
        <Chip href={link.canonicalPath}>{link.anchorText}</Chip>
      </li>
    )
  })

  return (
    <GuideSection heading="近隣のスポットから探す" size="small">
      <ReadMoreAccordion color="blue" size={isPc ? 'small' : 'large'}>
        <ul className={hstack({ gap: '2', flexWrap: 'wrap', px: '3', _pc: { px: '0' } })}>
          {links}
        </ul>
      </ReadMoreAccordion>
    </GuideSection>
  )
}
